"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const Month_1 = require("./atoms/Month");
const ScrollCalendarButton_1 = require("./atoms/ScrollCalendarButton/ScrollCalendarButton");
const S = __importStar(require("./Calendar.style"));
const CalendarHook_1 = __importDefault(require("./CalendarHook"));
const HeaderToggle_1 = __importDefault(require("./HeaderToggle/HeaderToggle"));
const Calendar = ({ streamId, minCalendarDate, maxCalendarDate, onDayClick, selectedTimestamp, isLoading, }) => {
    const { threeMonthsData, dateReference, isLeftButtonDisabled, isRightButtonDisabled, handleLeftClick, handleRightClick, } = (0, CalendarHook_1.default)({ streamId, minCalendarDate, maxCalendarDate });
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobileView = (0, useScreenSizeDetection_1.default)();
    const sortedThreeMonthsData = (0, react_1.useMemo)(() => (isMobileView ? [...threeMonthsData].reverse() : threeMonthsData), [threeMonthsData, isMobileView]);
    // Use timestamp (number) instead of Date.
    const handleDayClick = (0, react_1.useCallback)((timestamp) => {
        if (timestamp === undefined || timestamp === null)
            return;
        if (selectedTimestamp !== null && timestamp === selectedTimestamp) {
            onDayClick(null);
        }
        else {
            onDayClick(timestamp);
        }
    }, [selectedTimestamp, onDayClick]);
    const MobileSwipeComponent = () => (react_1.default.createElement(S.MobileSwipeContainer, null,
        react_1.default.createElement(ScrollCalendarButton_1.ScrollCalendarButton, { disabled: isLeftButtonDisabled, direction: -1 /* MovesKeys.MOVE_BACKWARD */, handleClick: handleLeftClick }),
        react_1.default.createElement(S.DateField, null,
            react_1.default.createElement("span", null, dateReference.firstVisibleDataPointDate),
            react_1.default.createElement("span", null, "-"),
            react_1.default.createElement("span", null, dateReference.lastVisibleDataPointDate)),
        react_1.default.createElement(ScrollCalendarButton_1.ScrollCalendarButton, { disabled: isRightButtonDisabled, direction: 1 /* MovesKeys.MOVE_FORWARD */, handleClick: handleRightClick })));
    const DesktopSwipeComponent = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.DesktopSwipeLeftContainer, null,
            react_1.default.createElement(ScrollCalendarButton_1.ScrollCalendarButton, { disabled: isLeftButtonDisabled, direction: -1 /* MovesKeys.MOVE_BACKWARD */, handleClick: handleLeftClick })),
        react_1.default.createElement(S.DesktopSwipeRightContainer, null,
            react_1.default.createElement(ScrollCalendarButton_1.ScrollCalendarButton, { disabled: isRightButtonDisabled, direction: 1 /* MovesKeys.MOVE_FORWARD */, handleClick: handleRightClick }))));
    const CalendarContent = () => (react_1.default.createElement(react_1.default.Fragment, null,
        isMobileView && react_1.default.createElement(MobileSwipeComponent, null),
        react_1.default.createElement(S.ThreeMonths, null,
            !isMobileView && react_1.default.createElement(DesktopSwipeComponent, null),
            sortedThreeMonthsData.map((month) => (react_1.default.createElement(Month_1.Month, Object.assign({ key: month.monthName }, month, { onDayClick: handleDayClick, selectedTimestamp: selectedTimestamp })))))));
    return (sortedThreeMonthsData && (react_1.default.createElement(S.CalendarContainer, null,
        react_1.default.createElement(HeaderToggle_1.default, { titleText: t("calendarHeader.calendarTitle"), startDate: dateReference.firstVisibleDataPointDate, endDate: dateReference.lastVisibleDataPointDate, componentToToggle: react_1.default.createElement(CalendarContent, null) }))));
};
exports.Calendar = Calendar;
